import React from 'react';
import "./singleMetric.css";
import "../../common/css/component.css";

function SingleMetric({ metricLabel, metricValue }) {
    return (
        <div className="component-container-no-border">
            <div className="metricValue">{metricValue}</div>
            <div className="metricLabel">{metricLabel}</div>
        </div>
    );
}

export default SingleMetric;
